import { useTranslation } from "react-i18next";

const TemporaryResidence = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 py-6">
      {/* Field */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.field_title")}
      </p>
      <p>{t("instructions.instructions_list.temporary_residence.field")}</p>

      {/* Implementing agency */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.implementing_agency_title")}
      </p>
      <p>{t("instructions.instructions_list.temporary_residence.implementing_agency")}</p>

      {/* Service level */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.service_level_title")}
      </p>
      <p>{t("instructions.instructions_list.temporary_residence.service_level")}</p>

      {/* How to do it */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.how_to_do_it_title")}
      </p>
      <p>
        <span className="font-semibold">{t("instructions.instructions_list.temporary_residence.how_to_do_it.direct")}</span><br />
        <span className="font-semibold">{t("instructions.instructions_list.temporary_residence.how_to_do_it.indirect")}</span>
      </p>

      {/* Execution order */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.execution_order_title")}
      </p>
      <ul className="list-disc space-y-2 ml-4">
        {Array.from({ length: 5 }).map((_, idx) => (
          <li key={idx}>
            {t(`instructions.instructions_list.temporary_residence.execution_order.step${idx + 1}`)}
          </li>
        ))}
      </ul>

      {/* Deadline */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.deadline_title")}
      </p>
      <ul className="list-disc space-y-2 ml-4">
        <li>
          <span className="font-semibold">{t("instructions.instructions_list.temporary_residence.deadline.direct_title")}</span>{" "}
          {t("instructions.instructions_list.temporary_residence.deadline.direct")}
        </li>
        <li>
          <span className="font-semibold">{t("instructions.instructions_list.temporary_residence.deadline.indirect_title")}</span>{" "}
          {t("instructions.instructions_list.temporary_residence.deadline.indirect")}
        </li>
      </ul>

      {/* Fees */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.fees_title")}
      </p>
      <p>{t("instructions.instructions_list.temporary_residence.fees")}</p>

      {/* Profile Element */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.profile_element_title")}
      </p>
      <p className="font-semibold">{t("instructions.instructions_list.temporary_residence.profile_element.title")}</p>
      <p className="font-semibold">{t("instructions.instructions_list.temporary_residence.profile_element.police_unit.title")}</p>
      {/* Bảng đăng ký tại đơn vị */}
      <table className="w-full table-auto border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">#</th>
            <th className="border px-2 py-1">Document</th>
            <th className="border px-2 py-1">Form</th>
            <th className="border px-2 py-1">Quantity</th>
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2].map((idx) => (
            <tr key={idx}>
              <td className="border px-2 py-1 text-center">{idx + 1}</td>
              <td className="border px-2 py-1">{t(`instructions.instructions_list.temporary_residence.profile_element.police_unit.table1.${idx}.document_type`)}</td>
              <td className="border px-2 py-1 text-center">{t(`instructions.instructions_list.temporary_residence.profile_element.police_unit.table1.${idx}.form`)}</td>
              <td className="border px-2 py-1 text-center">{t(`instructions.instructions_list.temporary_residence.profile_element.police_unit.table1.${idx}.quantity`)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="font-semibold mt-4">{t("instructions.instructions_list.temporary_residence.profile_element.list_registration.title")}</p>
      {/* Bảng đăng ký theo danh sách */}
      <table className="w-full table-auto border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">#</th>
            <th className="border px-2 py-1">Document</th>
            <th className="border px-2 py-1">Form</th>
            <th className="border px-2 py-1">Quantity</th>
          </tr>
        </thead>
        <tbody>
          {[0, 1].map((idx) => (
            <tr key={idx}>
              <td className="border px-2 py-1 text-center">{idx + 1}</td>
              <td className="border px-2 py-1">{t(`instructions.instructions_list.temporary_residence.profile_element.list_registration.table2.${idx}.document_type`)}</td>
              <td className="border px-2 py-1 text-center">{t(`instructions.instructions_list.temporary_residence.profile_element.list_registration.table2.${idx}.form`)}</td>
              <td className="border px-2 py-1 text-center">{t(`instructions.instructions_list.temporary_residence.profile_element.list_registration.table2.${idx}.quantity`)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Requirements */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.requirements_conditions_title")}
      </p>
      <p>{t("instructions.instructions_list.temporary_residence.requirements_conditions")}</p>

      {/* Legal Basis */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.legal_basis_title")}
      </p>
      <ul className="list-disc space-y-2 ml-4">
        {[0, 1, 2, 3, 4].map((idx) => (
          <li key={idx}>{t(`instructions.instructions_list.temporary_residence.legal_basis.${idx}`)}</li>
        ))}
      </ul>

      {/* Implementation Results */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t("instructions.instructions_list.temporary_residence.implementation_results_title")}
      </p>
      <ul className="list-disc space-y-2 ml-4">
        {[0, 1, 2, 3].map((idx) => (
          <li key={idx}>{t(`instructions.instructions_list.temporary_residence.implementation_results.${idx}`)}</li>
        ))}
      </ul>
    </div>
  );
};

export default TemporaryResidence;
